/**
 * Раскладка сетки карточек игроков по их числу: 1 — одна, 2 и 3 — в ряд,
 * 4 — 2×2, 5–6 — 3×2. Значение — атрибут data-layout сетки (см. LobbyDesktop.css).
 *
 * @param {number} cardsCount
 * @returns {string}
 */
export const getOpponentsGridLayout = (cardsCount) => {
  if (cardsCount <= 1) return '1x1';
  if (cardsCount === 2) return '2x1';
  if (cardsCount === 3) return '3x1';
  if (cardsCount === 4) return '2x2';
  return '3x2';
};
